import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ApplicationAppService from '../../application/platform/application-app-service';
import dayjs from 'dayjs';
import React from 'react';
import { useBaseLayoutController } from '../base-layout/context/base-layout-controller';
import { DefaultMessageProps } from './default-message';


export function InactivityLogoutTimer({ children }: { children: React.ReactNode }) {
    const authenticationData = ApplicationAppService.getAuthenticationData();
    const { showMessage } = useBaseLayoutController();
    const location = useLocation();
    const navigate = useNavigate();

    const checkForInactivity = () => {
        if (authenticationData?.expireTime !== undefined) {
            if (dayjs(authenticationData?.expireTime) < dayjs() && location.pathname !== '/') {
                ApplicationAppService.clearAuthenticationData();
                navigate('/');
                showMessage({ type: 'warning', message: 'Foi identificado uma inatividade no sistema. Usuário foi deslogado.' } as DefaultMessageProps);
            }
            else if (dayjs(authenticationData?.expireTime) < dayjs().add(-2, 'seconds')) {
                showMessage({ type: 'warning', message: 'Foi identificado uma inatividade no sistema. Caso não ocorra atividade você será deslogado. ' } as DefaultMessageProps);
            }
        }
    };

    const updateExpiryTime = () => {
        ApplicationAppService.setExpireTime(dayjs().add(30, 'minutes'));
    };

    useEffect(() => {
        const interval = setInterval(() => {
            checkForInactivity();
        }, 5000); // Check for inactivity every 5 seconds
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const events = ["mousedown",
            "mousemove",
            "wheel",
            "keydown",
            "touchstart",
            "scroll"];

        const update = () => {
            updateExpiryTime();
        };

        events.forEach(event => window.addEventListener(event, update));

        return () => {
            events.forEach(event => window.removeEventListener(event, update));
        };
    }, []);

    return (
        <React.Fragment>
            {children}
        </React.Fragment>
    )
}

